/* eslint-disable react/no-unescaped-entities */
import { Card } from '@/components';
import { icMl, icInt, icCupml } from '@/components/GenericsTournaments/Icons/';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import useTourney from '@/hooks/useTourney';

export const InfoContent = () => {
  const { isDesktop } = useIsDesktop();
  const { tourneyData } = useTourney();

  return (
    <>
      {isDesktop ? (
        <div className="text-left overflow-y-auto scrollbar-hide max-h-[80vh] [&::-webkit-scrollbar]:hidden [-ms-overflow-style:'none'] [scrollbar-width:'none']">
          <h6 className="lg:text-center lg:text-base text-sm font-bold text-gdt-blue-header flex lg:items-center max-sm:max-w-[250px]">
            <figure className="min-w-8">
              <img alt="Icono de pelota" src={icMl} />
            </figure>
            <span className="ps-2">¿Qué son las Miniligas?</span>
          </h6>
          <p className="my-2">
            <span className="font-semibold">
              Las Miniligas son competencias especiales dentro del juego de Gran
              DT.
            </span>
            <br />
            {`Cada una está compuesta por ${tourneyData.maxNumParticipants} participantes que tienen armado su equipo de Primera. Los equipos que conforman cada Miniliga competirán entre sí en desafios mano a mano, determinados por un fixture interno de la Miniliga en cuestion.`}
          </p>
          <p>Los puntos se computarán de la siguiente manera:</p>
          <ul className="list-disc list-inside mt-2">
            <li>
              Desafío ganado (más puntos que el adversario) suma 3 (tres)
              puntos.
            </li>
            <li>
              Desafío perdido (menos puntos que el adversario) suma 0 (cero)
              puntos.
            </li>
            <li>
              Desafío empatado (igual puntos que el adversario) suma 1 (un)
              punto.
            </li>
          </ul>
          <br />
          <p>En cada Miniliga se generará un Ranking interno.</p>
          <br />
          <h6 className="lg:text-center lg:text-base text-sm font-bold text-gdt-blue-header flex lg:items-center max-sm:max-w-[250px]">
            <figure className="min-w-8">
              <img alt="Icono de pelota" src={icInt} />
            </figure>
            <span className="ps-2">¿Cómo se participa?</span>
          </h6>
          <p className="my-2">
            <span className="font-semibold">
              Hay dos formas de participar de las Miniligas:
            </span>
            <br />
            <ul className="list-disc list-inside mt-2">
              <li>
                {`En la fecha de inicio de las Miniligas, Gran DT generará Miniligas automáticas con ${tourneyData.maxNumParticipants} elegidos al azar.`}
              </li>
              <li>
                De manera no automática: Los participantes podrán crear su
                Miniliga, ponerle un nombre e invitar a{' '}
                {tourneyData.maxNumParticipants - 1} amigos a competir en ella.
                Todas las Miniligas que cuenten con{' '}
                {tourneyData.maxNumParticipants} participantes antes del inicio
                de la competencia quedarán activas.
              </li>
            </ul>
          </p>
          <br />
          <h6 className="lg:text-center lg:text-base text-sm font-bold text-gdt-blue-header flex lg:items-center max-sm:max-w-[250px]">
            <figure className="min-w-8">
              <img alt="Icono de copa" src={icCupml} />
            </figure>
            <span className="ps-2">Premios</span>
          </h6>
          <div className="">
            <p className="my-2">
              El ganador de cada Miniliga pasará a la Gran Final y participará
              por uno de estos{' '}
              <span className="font-semibold">5 premios en efectivo:</span>
              <br />
              <br />
              1° puesto $1.500.000
              <br />
              <br />
              2° puesto $1.000.000
              <br />
              <br />
              3° puesto $500.000
              <br />
              <br />
              4° puesto $300.000
              <br />
              <br />
              5° puesto $200.000
            </p>
          </div>
        </div>
      ) : (
        <div className="flex flex-col gap-4">
          <Card className="!px-6 !pb-8 !w-auto !pt-4 bg-white">
            <h6 className="lg:text-center lg:text-base text-sm font-bold text-gdt-blue-header flex lg:items-center max-sm:max-w-[250px]">
              <figure className="min-w-8">
                <img alt="Icono de pelota" src={icMl} />
              </figure>
              <span className="ps-2">¿Qué son las Miniligas?</span>
            </h6>
            <div className="m-4">
              <p className="lg:mt-7">
                <span className="font-semibold">
                  Las Miniligas son competencias especiales dentro del juego de
                  Gran DT.
                </span>
                <br />
                {`Cada una está compuesta por ${tourneyData.maxNumParticipants} participantes que tienen armado su equipo de Primera. Los equipos que conforman cada Miniliga competirán entre sí en desafios mano a mano, determinados por un fixture interno de la Miniliga en cuestion.`}
              </p>
              <p>Los puntos se computarán de la siguiente manera:</p>
              <ul className="list-disc list-inside mt-2">
                <li>
                  Desafío ganado (más puntos que el adversario) suma 3 (tres)
                  puntos.
                </li>
                <li>
                  Desafío perdido (menos puntos que el adversario) suma 0 (cero)
                  puntos.
                </li>
                <li>
                  Desafío empatado (igual puntos que el adversario) suma 1 (un)
                  punto.
                </li>
              </ul>
              <br />
              <p>En cada Miniliga se generará un Ranking interno.</p>
            </div>
          </Card>
          <Card className="!px-6 !pb-8 !w-auto !pt-4 bg-white">
            <h6 className="lg:text-center lg:text-base text-sm font-bold text-gdt-blue-header flex lg:items-center max-sm:max-w-[250px]">
              <figure className="min-w-8">
                <img alt="Icono de pelota" src={icInt} />
              </figure>
              <span className="ps-2">¿Cómo se participa?</span>
            </h6>
            <div className="m-4">
              <p className="lg:mt-7">
                <span className="font-semibold">
                  Hay dos formas de participar de las Miniligas:
                </span>
                <br />
                <ul className="list-disc list-inside mt-2">
                  <li>
                    {`En la fecha de inicio de las Miniligas, Gran DT generará Miniligas automáticas con ${tourneyData.maxNumParticipants} elegidos al azar.`}
                  </li>
                  <li>
                    De manera no automática: Los participantes podrán crear su
                    Miniliga, ponerle un nombre e invitar a{' '}
                    {tourneyData.maxNumParticipants - 1} amigos a competir en
                    ella. Todas las Miniligas que cuenten con{' '}
                    {tourneyData.maxNumParticipants} participantes antes del
                    inicio de la competencia quedarán activas.
                  </li>
                </ul>
              </p>
            </div>
          </Card>
          <Card className="!px-6 !pb-8 !w-auto !pt-4 bg-white">
            <h6 className="lg:text-center lg:text-base text-sm font-bold text-gdt-blue-header flex lg:items-center max-sm:max-w-[250px]">
              <figure className="min-w-8">
                <img alt="Icono de copa" src={icCupml} />
              </figure>
              <span className="ps-2">Premios</span>
            </h6>
            <div className="m-4">
              <p className="lg:mt-7">
                El ganador de cada Miniliga pasará a la Gran Final y participará
                por uno de estos{' '}
                <span className="font-semibold">5 premios en efectivo:</span>
                <br />
                <br />
                1° puesto $1.500.000
                <br />
                <br />
                2° puesto $1.000.000
                <br />
                <br />
                3° puesto $500.000
                <br />
                <br />
                4° puesto $300.000
                <br />
                <br />
                5° puesto $200.000
              </p>
            </div>
          </Card>
        </div>
      )}
    </>
  );
};
